import { ThermometerLowIcon } from './ThermometerLowIcon';

/**
 * author: Michael Richins
 * id DBD8C754-85C4-43C4-BEA8-BCFEDB30B382
 * name thermometer-low
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-low.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const TemperatureLowIcon = ThermometerLowIcon;
export default TemperatureLowIcon